// extracted by mini-css-extract-plugin
export default {"link":"iM-z","disabled":"jM-z"};